import { SessionStorageKey } from '../enums/SessionStorageKey';

export function storeLoginRedirectPath() {
  localStorage.setItem(SessionStorageKey.LoginRedirect, window.location.href);
}
